/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
    QueryFunction,
    QueryKey,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    GetCountryCodes200,
    GetLocationCodes200,
    GetLocationCodesParams,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * Returns all country codes for use in dropdowns/autocomplete
 * @summary Get list of ISO 3166-1 country codes
 */
export const getCountryCodes = (signal?: AbortSignal) => {
    return customInstance<GetCountryCodes200>({
        url: `/common/country-codes`,
        method: 'GET',
        signal,
    });
};

export const getGetCountryCodesQueryKey = () => {
    return [`/common/country-codes`] as const;
};

export const getGetCountryCodesQueryOptions = <
    TData = Awaited<ReturnType<typeof getCountryCodes>>,
    TError = APIErrorResponseResponse,
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCountryCodes>>, TError, TData>;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCountryCodesQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCountryCodes>>> = ({ signal }) =>
        getCountryCodes(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getCountryCodes>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetCountryCodesQueryResult = NonNullable<Awaited<ReturnType<typeof getCountryCodes>>>;
export type GetCountryCodesQueryError = APIErrorResponseResponse;

/**
 * @summary Get list of ISO 3166-1 country codes
 */

export function useGetCountryCodes<
    TData = Awaited<ReturnType<typeof getCountryCodes>>,
    TError = APIErrorResponseResponse,
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCountryCodes>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetCountryCodesQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * Returns location codes, optionally filtered by country or search query
 * @summary Get list of UN/LOCODE location codes
 */
export const getLocationCodes = (params?: GetLocationCodesParams, signal?: AbortSignal) => {
    return customInstance<GetLocationCodes200>({
        url: `/common/location-codes`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetLocationCodesQueryKey = (params?: GetLocationCodesParams) => {
    return [`/common/location-codes`, ...(params ? [params] : [])] as const;
};

export const getGetLocationCodesQueryOptions = <
    TData = Awaited<ReturnType<typeof getLocationCodes>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetLocationCodesParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getLocationCodes>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetLocationCodesQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationCodes>>> = ({ signal }) =>
        getLocationCodes(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getLocationCodes>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetLocationCodesQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationCodes>>>;
export type GetLocationCodesQueryError = APIErrorResponseResponse;

/**
 * @summary Get list of UN/LOCODE location codes
 */

export function useGetLocationCodes<
    TData = Awaited<ReturnType<typeof getLocationCodes>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetLocationCodesParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getLocationCodes>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetLocationCodesQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}
